module.exports = __webpack_public_path__ + "img/i.3dba5fb2.jpg";